import * as React from "react"
import { useState, useEffect } from 'react';
import * as styles from './header.module.scss';
import Nav from "../nav";
import { Link } from "gatsby"
// import Logo from "../logo";
import { StaticImage } from "gatsby-plugin-image";
import { useSiteMetadata } from "../../hooks/use-site-metadata"

const Header = ({ headerClassName = 'default' }) => {

  const { title: siteTitle } = useSiteMetadata();

  const [headerClass, setScroll] = useState(null);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  const handleScroll = (e) => {
    if (window.scrollY >= 100) {
      setScroll(styles.fixedHeader);
    } else {
      setScroll(null);
    }
  };

  return (
    <header className={`${styles.siteHeader} ${headerClass} ${headerClassName}`}>
      <Link to="/">
        {/* <Logo className={styles.siteLogo} /> */}
        <StaticImage src="../../images/logo.png" placeholder="blurred" loading="eager" layout="constrained" width={200} alt={`${siteTitle} - Go to homepage`} className={styles.siteLogo} />
      </Link>
      <Nav />
    </header>
  )
}

export default Header